export default __webpack_public_path__ + "static/media/infer.83ceafe4.svg";